<script setup lang="ts">
type SidebarMenuProps = {
  title: string;
};

defineProps<SidebarMenuProps>();
</script>

<template>
  <section class="flex flex-col gap-2">
    <h4 class="label-small hidden uppercase text-white lg:block">
      {{ $props.title }}
    </h4>
    <div class="flex flex-col gap-1">
      <slot />
    </div>
  </section>
</template>
